import { render, staticRenderFns } from "./MessageEditor.vue?vue&type=template&id=064fcf9c&scoped=true&"
import script from "./MessageEditor.vue?vue&type=script&lang=js&"
export * from "./MessageEditor.vue?vue&type=script&lang=js&"
import style0 from "./MessageEditor.vue?vue&type=style&index=0&id=064fcf9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064fcf9c",
  null
  
)

export default component.exports